export default __webpack_public_path__ + "static/media/Medicos.124eb1c6.svg";